import {
  ChamberMemberProPagePermissionsEnum,
  ChamberPerksAppAdminConsolePagePermissionsEnum,
  ChamberStaffUsagePermissionsInput,
} from "../../../../../graphql/types";
import { PermissionSelection } from "./types";

export const toChamberStaffUsagePermissionsInput = ({
  selection,
}: {
  selection: PermissionSelection;
}): ChamberStaffUsagePermissionsInput => ({
  chamberMemberPro_EnabledPages:
    selection.chamberMemberPro as ChamberMemberProPagePermissionsEnum[],
  chamberPerksAppAdminConsole_EnabledPages:
    selection.chamberPerksAppAdminConsole as ChamberPerksAppAdminConsolePagePermissionsEnum[],
});
